import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
} from "../actions";

import UserImage from "../assets/images/user.png";
import biharLogoWhite from "../assets/images/bihar-logo-red.png";
import Sidebar from "./navbar/sidebar";

class NavbarMenu extends React.Component {
  componentDidMount() {
    const data = JSON.parse(localStorage.getItem("call-center-admin-token"));
    if (data) {
      const hideNav = [
        "Block Education Officer", "District Education Officer",
        "State Project Director", "Additional State Project Director, Bihar",
        "Additional State Project Director- Programme", "Director, Secondary",
        "Director, Primary", "Director, MDM", "Director, Administration",
        "Director, SCERT", "Dy. Director, Education",
        "Assistant Director, Education",
        "Additional State Project Director - Academic", "DRT",
      ];
      if (hideNav.includes(data.vchDesignationName)) {
        const mob = document.getElementById("mob");
        if (mob) mob.style.display = "none";
      }
    }
  }

  toggleSidebar = () => {
    document.body.classList.toggle("sidebar-toggled");
  };

  closeSidebar = () => {
    document.body.classList.remove("sidebar-toggled");
  };

  render() {
    document.body.classList.add(this.props.themeColor);

    return (
      <div id="mob">
        <nav className="navbar navbar-fixed-top ccc-navbar">
          <div className="container-fluid">
            <div className="navbar-brand">
              <button
                type="button"
                className="ccc-nav-toggle mr-2"
                onClick={this.toggleSidebar}
                aria-label="Toggle sidebar"
                title="Toggle sidebar"
              >
                <i className="fa fa-bars" />
              </button>
              <img src={biharLogoWhite} alt="Bihar Government" />
              <a href="/" className="navbar-title">
                Command &amp; Control Center
                <span>Education Department</span>
              </a>
            </div>

            <div className="navbar-right">
              <div id="navbar-menu">
                <ul className="nav navbar-nav">
                  <li>
                    <a href="/logout" className="icon-menu" title="Logout">
                      <i className="fa fa-sign-out" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>

        <div
          className="ccc-sidebar-overlay"
          onClick={this.closeSidebar}
          aria-hidden="true"
        />

        <div id="left-sidebar" className="sidebar">
          <div className="sidebar-scroll">
            <div className="user-account">
              <div className="ccc-user-profile">
                <img
                  src={UserImage}
                  className="rounded-circle user-photo"
                  alt="Profile"
                />
                <p className="user-name">{this.props.auth?.auth?.userName}</p>
                {this.props.auth?.auth?.userType && (
                  <span className="ccc-user-role">{this.props.auth.auth.userType}</span>
                )}
              </div>
              <Sidebar onNavigate={this.closeSidebar} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NavbarMenu.propTypes = {
  addClassactive: PropTypes.array.isRequired,
  addClassactiveChild: PropTypes.array.isRequired,
  addClassactiveChildApp: PropTypes.array.isRequired,
  addClassactiveChildFM: PropTypes.array.isRequired,
  addClassactiveChildBlog: PropTypes.array.isRequired,
  addClassactiveChildUI: PropTypes.array.isRequired,
  addClassactiveChildWidgets: PropTypes.array.isRequired,
  addClassactiveChildAuth: PropTypes.array.isRequired,
  addClassactiveChildPages: PropTypes.array.isRequired,
  addClassactiveChildForms: PropTypes.array.isRequired,
  addClassactiveChildTables: PropTypes.array.isRequired,
  addClassactiveChildChart: PropTypes.array.isRequired,
  addClassactiveChildMaps: PropTypes.array.isRequired,
  themeColor: PropTypes.string.isRequired,
  generalSetting: PropTypes.array.isRequired,
  toggleNotification: PropTypes.bool.isRequired,
  toggleEqualizer: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ navigationReducer, Auth }) => {
  const {
    addClassactive, addClassactiveChild, addClassactiveChildApp,
    addClassactiveChildFM, addClassactiveChildBlog, addClassactiveChildUI,
    addClassactiveChildWidgets, addClassactiveChildAuth, addClassactiveChildPages,
    addClassactiveChildForms, addClassactiveChildTables, addClassactiveChildChart,
    addClassactiveChildMaps, themeColor, generalSetting, toggleNotification,
    toggleEqualizer, menuProfileDropdown, sideMenuTab, isToastMessage,
  } = navigationReducer;
  return {
    addClassactive, addClassactiveChild, addClassactiveChildApp,
    addClassactiveChildFM, addClassactiveChildBlog, addClassactiveChildUI,
    addClassactiveChildWidgets, addClassactiveChildAuth, addClassactiveChildPages,
    addClassactiveChildForms, addClassactiveChildTables, addClassactiveChildChart,
    addClassactiveChildMaps, themeColor, generalSetting, toggleNotification,
    toggleEqualizer, menuProfileDropdown, sideMenuTab, isToastMessage,
    auth: Auth,
  };
};

export default connect(mapStateToProps, {
  onPressDashbord, onPressDashbordChild, onPressThemeColor,
  onPressGeneralSetting, onPressNotification, onPressEqualizer,
  onPressSideMenuToggle, onPressMenuProfileDropdown, onPressSideMenuTab,
  tostMessageLoad,
})(NavbarMenu);
